<i18n>
    {
        "ru": {
            "headline": "Электронный билет будет отправлен на указанные E-mail и телефон, будьте внимательны при вводе"
        },
        "en": {
            "headline": "The e-ticket will be sent to the specified E-mail and phone, be careful when entering"
        }
    }
</i18n>

<template>
    <span :class="$style.advice">{{ $t("headline") }}</span>
</template>

<script>
export default {
    name: "FormAdvice",
};
</script>

<style module>
.advice {
    display: block;
    margin-bottom: 24px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    line-height: 140%;
}
</style>
